export default {
  hour: "Stunde",
  hours: "Stunden",
  minute: "Minute",
  minutes: "Minuten",
};
